import CompanyFranchiseTitleRank from 'components/Company/CompanyFranchiseTitleRank';
import Link from 'components/Globals/Base/Link';
import * as S from './RankWithLabelStyles';

export interface RankWithLabelProps {
  name: string;
  rank: number;
  showRank?: boolean;
  rankDataCy?: string;
  labelDataCy?: string;
  linkDataCy?: string;
  className?: string;
  uri: string;
  companyName: string;
}

const RankWithLabel = ({
  name,
  className = '',
  rank,
  rankDataCy = '',
  labelDataCy = '',
  showRank = false,
  uri = '',
  linkDataCy = '',
  companyName,
}: RankWithLabelProps) => (
  <Link
    key={`${uri}index`}
    href={uri}
    data-cy={linkDataCy}
    aria-label={`${companyName} ranking on ${name}`}
  >
    <S.Wrapper className={className}>
      <CompanyFranchiseTitleRank
        showRank={showRank}
        companyRanking={rank}
        rankDataCy={rankDataCy}
      />
      <S.Label
        className='label'
        data-cy={labelDataCy}
      >
        {name}
      </S.Label>
    </S.Wrapper>
  </Link>
);

export default RankWithLabel;
